// Generic errors
export const ERROR_NOT_FOUND = new Error("Not found");

export type WiseError = {
    code?: string;
    messages?: string[];
}
